import { axiosGet, axiosPost } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";

const getEmployeesUrl     = '/api/admin/employee/getEmployees';
const postEmployeeUrl     = '/api/admin/employee/postEmployee';

export const getEmployeeList = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getEmployeesUrl, { headers: { auth_token: `bearer ${token}` }} );
    return response;
}

export const postEmployee = async (employee) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        postEmployeeUrl,
        { employee },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};